export default __webpack_public_path__ + "static/media/rain.af391416.jpg";